export default __webpack_public_path__ + "static/media/w3.36ce8fdf.png";